import { dbService } from './db';
import { useSubmit, useOutletContext, useLoaderData, useSubmit, useNavigate } from "react-router";
import React, { useState } from 'react'
import { ArrowDownIcon } from '@heroicons/react/24/outline'

export async function clientLoader({ }) {
  let db = await dbService.createDB();
  let shipmentActions = (await db.getAll("shipmentAction"));
  return { shipmentActions };
}

export function Status() {
  const { shipmentActions } = useLoaderData();
  const { activeAccount } = useOutletContext();
  let submit = useSubmit();
  let navigate = useNavigate();

  return (
    <>
      <div className="">
        <div className="top-0 left-0 p-6">
          <img
            alt="PVS"
            src="/logo.svg"
            className="h-8"
          />
        </div>
        <div className="absolute top-0 right-0 p-6">
          <img
            alt="Yellow"
            src="/yellow.svg"
            className="h-8"
          />
        </div>
      </div>
      <div className="px-2">
        <h1 className="text-3xl font-inter font-bold pt-15 p-6">Sync status</h1>

        <table className="table-auto w-full h-4/8 overflow-scroll">
          <thead>
            <tr className="font-semibold">
              <td>Customer</td>
              <td>Shipment Id</td>
              <td>Order Id</td>
              <td>Synced</td>
            </tr>
          </thead>
          <tbody>
            {shipmentActions && shipmentActions.map((x, i) =>
              <tr key={x.id}>
                <td>{x.order.customer_number}</td>
                <td>{x.shipment.shipment_id}</td>
                <td>{x.order_id}</td>
                <td>{x.synced}</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="absolute -left-16 w-32 h-32 bg-pvs-gray rotate-45 rounded-lg top-2/3 ">

        </div>

        <div className="absolute w-32 h-32 top-2/3 flex items-center justify-center ">
          <ArrowDownIcon className="h-8 pr-12 bold"
            onClick={() => {
              submit(
                { token: activeAccount.idToken, action: "goToShipment" },
                { action: "/user", method: "post" }
              );
            }} ></ArrowDownIcon>
        </div>

      </div>
    </>
  );
}

